import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "app/containers/Features/containers/Ticket/redux/initialState";
import { RootState } from "types";

const domain = (state: RootState) => state?.ticketDetailsState || initialState;

export const selectTicketDetails = createSelector(
  [domain],
  (state) => state.details.result,
);

export const selectDetailsData = selectTicketDetails;
export const selectTicketLoading = createSelector(
  [domain],
  (state) => state.details.loading,
);

export const selectActiveDetailsTab = createSelector(
  [domain],
  (state) => state?.activeDetailsTab,
);

export const selectDuplicateAction = createSelector(
  [domain],
  (state) => state?.duplicateAction,
);

export const selectArchiveAction = createSelector(
  [domain],
  (state) => state?.archiveAction,
);

export const selectChangeTicketNameAction = createSelector(
  [domain],
  (state) => state?.changeTicketNameAction,
);

export const selectToggleEffortEstimateMenu = createSelector(
  [domain],
  (state) => state?.toggleEffortEstimateMenu,
);

export const selectUpdateEffortEstimatedLoading = createSelector(
  [domain],
  (state) => state?.updateEffortEstimatedLoading,
);

export const selectActionItemsState = createSelector(
  [domain],
  (state) => state?.actionItems,
);

// Ticket Description related selectors --
export const selectEnableTicketDescription = createSelector(
  [domain],
  (state) => state?.enableTicketDescription,
);

export const selectEnableAddNewTemplateForm = createSelector(
  [domain],
  (state) => state?.enableAddNewTemplateForm,
);

export const selectTicketDescriptionForm = createSelector(
  [domain],
  (state) => state?.ticketDescriptionForm,
);

export const selectUpdateTicketDescriptionLoading = createSelector(
  [domain],
  (state) => state?.updateTicketDescriptionLoading,
);
// Attachment related selectors --
export const selectAttachmentState = createSelector(
  [domain],
  (state) => state?.attachmentState,
);

export const selectAttachmentFiles = createSelector(
  [selectAttachmentState],
  (state) => state?.files || [],
);

export const selectAttachmentPreviewFileId = createSelector(
  [selectAttachmentState],
  (state) => state?.previewFileId || null,
);

export const selectAttachmentPreviewFileIds = createSelector(
  [selectAttachmentState],
  (state) => state?.previewFileIds || null,
);

export const selectAttachmentIsPreviewOpen = createSelector(
  [selectAttachmentState],
  (state) => state?.isPreviewOpen || false,
);

export const selectAttachmentPreviewUrlLoading = createSelector(
  [selectAttachmentState],
  (state) => state?.previewUrlLoading || false,
);

export const selectAttachmentTextPreviewState = createSelector(
  [selectAttachmentState],
  (state) =>
    state?.textPreview || {
      fileUrl: null,
      content: null,
      isLoading: false,
      hasError: false,
    },
);

export const selectRenameAttachmentLoading = createSelector(
  [selectAttachmentState],
  (state) => state?.renameAttachmentLoading || false,
);

